import { PanelGroup } from '@cbridge-tools/resizable-panels';
import { MarkupProfileListSubscriber } from '@cbridge-packages/markup-profile';
import { SymbolGroupsSubscriber } from '@cbridge-packages/symbol-groups';
import { FlexNavigationPanel, SideFilterPanel, ConfigPageLayout, usePersistedPanelLayout, panelLayoutSettingKey } from '@cbridge-modules/layout';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { CoreSymbolGroupsFilter } from '@cbridge-modules/symbol-groups-filter';
import { MarkupProfilesNavigation } from '../navigation/MarkupProfilesNavigation/MarkupProfilesNavigation';

export function MarkupsLayout() {
  const sideLayoutProps = usePersistedPanelLayout(panelLayoutSettingKey(UserSettingsPage.ConfigMarkups, 'side'));

  return (
    <>
      <MarkupProfileListSubscriber />
      <SymbolGroupsSubscriber />

      <ConfigPageLayout settingsKey={UserSettingsPage.ConfigMarkups}>
        <PanelGroup direction={'vertical'} style={{ flex: '1 0 600px' }} {...sideLayoutProps}>
          <FlexNavigationPanel
            id={'list'}
            minSize={20}
            defaultSize={40}
          >
            <MarkupProfilesNavigation />
          </FlexNavigationPanel>
          <SideFilterPanel
            collapsible={true}
            defaultSize={60}
          >
            <CoreSymbolGroupsFilter />
          </SideFilterPanel>
        </PanelGroup>
      </ConfigPageLayout>
    </>
  );
}
